/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

function timeUnits(ms: number) {
    if (!Number.isInteger(ms)) {
        return null
    }

    function allocate(msUnit: any) {
        const units = Math.trunc(ms / msUnit)
        ms -= units * msUnit
        return units
    }

    return {
        // weeks: (604800000),
        //days: allocate(86400000),
        hours: allocate(3600000),
        minutes: allocate(60000),
        seconds: allocate(1000),
        //ms: ms
    }
}

class Token {
    private static storage_key: string = 'token';
    private token: string | null = null;

    constructor() {
        this.loadFromLocalStore();
    }

    private loadFromLocalStore() {
        this.token = window.localStorage.getItem(Token.storage_key);
    }

    public get(): string {
        return this.token ? this.token : "";
    }

    public set(token: string) {
        window.localStorage.setItem(Token.storage_key, token);
        this.loadFromLocalStore()
    }

    public del() {
        window.localStorage.removeItem(Token.storage_key)
        this.loadFromLocalStore()
    }

    public content(): any | null {
        if (!!this.token) {
            try {
                return JSON.parse(window.atob(this.token.split('.')[1]));
            } catch (e) {
                console.error(e);
            }
        }
        return null
    }

    public exp(): Date | null {
        let content = this.content()
        if (!!content) {
            try {
                return new Date(content['exp'] * 1000);
            } catch (e) {
            }
        }
        return null;
    }

    public iat(): Date | null {
        let content = this.content()
        if (!!content) {
            try {
                return new Date(content['iat'] * 1000);
            } catch (e) {
            }
        }
        return null;
    }

    public remaining(): number {
        let exp = this.exp();
        if (!!exp) {
            return exp.getTime() - new Date().getTime();
        } else {
            return -1;
        }
    }

    public age(): number {
        let iat = this.iat();
        if (!!iat) {
            return new Date().getTime() - iat.getTime()
        } else {
            return -1;
        }
    }

    public isExpired(): boolean {
        return this.remaining() <= 0;
    }

    public remainingStr(): string {
        let units = timeUnits(this.remaining());
        if (!this.isExpired() && !!units) {
            let h = String(units['hours']).padStart(2, "0");
            let m = String(units['minutes']).padStart(2, "0");
            let s = String(units['seconds']).padStart(2, "0");
            return units['hours'] == 0 ? (m + ":" + s) : (h + ":" + m + ":" + s);
        }
        return "00:00";
    }

    public exists(): boolean {
        return this.token !== null;
    }

}

export const token = new Token();